import { createSlice } from '@reduxjs/toolkit';
import routes from '../../../constants/routes';
import authenticationUtils from '../../../utils/authenticationUtils';

const initialState = {};

const logoutSlice = createSlice({
  name: 'logoutAdmin',
  initialState,
  reducers: {
    doLogout: (state) => {
      authenticationUtils.clearStorage();
      window.location.href = routes.ADMIN_LOGIN;
      // navigate.push(routes.ADMIN_LOGIN);
    }
  }
});
export const { doLogout } = logoutSlice.actions;
export default logoutSlice;
